import { render, staticRenderFns } from "./EfsMdDiseaseModal.vue?vue&type=template&id=0fb06a52&"
import script from "./EfsMdDiseaseModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports